import { render, staticRenderFns } from "./the-categories.vue?vue&type=template&id=caf77d5a&scoped=true"
import script from "./the-categories.vue?vue&type=script&lang=js"
export * from "./the-categories.vue?vue&type=script&lang=js"
import style0 from "./the-categories.vue?vue&type=style&index=0&id=caf77d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf77d5a",
  null
  
)

export default component.exports